import founderPortrait from "../assets/portrait-web.png";

function WhoWeAreScreen() {
  return (
    <section className="mx-auto w-full max-w-5xl space-y-6">
      <article className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
        <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">
          About Practidex
        </p>
        <h1 className="mb-4 text-3xl font-semibold text-slate-900">Who We Are</h1>
        <div className="grid gap-6 md:grid-cols-[1.2fr_0.8fr]">
          <div className="space-y-3 text-sm leading-7 text-slate-700">
            <p className="m-0">
              Practidex is a digital marketplace built for professionals who need practical,
              session-ready resources they can trust. The platform is designed to make discovery
              simpler, presentation clearer, and purchasing more confident for both buyers and
              creators.
            </p>
            <p className="m-0">
              We focus on useful professional materials, creator credibility, and a secure buying
              experience. That means clear product information, transparent account flows, and
              support that stays reachable when a visitor needs help before or after an order.
            </p>
            <p className="m-0">
              Our goal is to grow Practidex into a marketplace that feels reliable from the first
              visit: thoughtful presentation, trustworthy communication, and resources that support
              real clinical and educational work.
            </p>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              Support
            </p>
            <h2 className="text-lg font-semibold text-slate-900">Need to reach us?</h2>
            <p className="mt-2 text-sm leading-6 text-slate-600">
              For account, order, or marketplace questions, contact the Practidex team directly at{" "}
              <a
                href="mailto:contact@practidex.com"
                className="font-semibold text-sky-700 no-underline hover:text-sky-800"
              >
                contact@practidex.com
              </a>
              .
            </p>
            <p className="mt-3 text-sm leading-6 text-slate-600">
              If your message is about an order, include the account email and order reference when
              possible so we can help faster.
            </p>
          </div>
        </div>
      </article>

      <article className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
        <div className="grid gap-6 md:grid-cols-[280px_minmax(0,1fr)] md:items-center">
          <div className="mx-auto w-full max-w-[280px]">
            <div className="overflow-hidden rounded-2xl border border-slate-200 bg-slate-50 shadow-sm">
              <img
                src={founderPortrait}
                alt="El Amine Morabet, founder of Practidex"
                className="aspect-[4/5] w-full object-cover"
              />
            </div>
            <p className="mt-3 text-center text-xs leading-5 text-slate-500">
              Founder of Practidex
            </p>
          </div>

          <div>
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-sky-700">
              Founder
            </p>
            <h2 className="text-2xl font-semibold text-slate-900">El Amine Morabet</h2>
            <p className="mt-3 text-sm leading-7 text-slate-700">
              Practidex was founded by El Amine Morabet, an experienced speech therapist, with the aim of building a more credible,
              practical, and creator-friendly space for professional digital resources. The focus
              from the start has been to create a marketplace that feels dependable to visitors,
              useful to practitioners, and fair to creators who invest time in producing quality
              materials.
            </p>
            <p className="mt-3 text-sm leading-7 text-slate-700">
              The vision behind the platform is simple: make it easier for professionals to find
              resources worth using, while giving creators a clearer and more trustworthy way to
              present and sell their work online.
            </p>
          </div>
        </div>
      </article>
    </section>
  );
}

export default WhoWeAreScreen;
